interface CardErrorStateProps {
    message: string;
    onRetry: () => void;
    className?: string;
}

// Shared inline failure state for the Accounts Overview hub cards - same
// message + Retry affordance as CommunicationsTable's ErrorState, adapted from a table
// row to a flex-col card body so a query failure never silently renders as
// the card's "nothing here yet" empty state.
export function CardErrorState({ message, onRetry, className = '' }: CardErrorStateProps) {
    return (
        <div
            className={`flex-1 min-h-0 flex flex-col items-center justify-center gap-3 px-6 py-8 text-center ${className}`.trim()}
        >
            <p className="text-sm text-red-500 font-medium">{message}</p>
            <button
                type="button"
                onClick={onRetry}
                className="text-xs text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg px-3 py-1.5 transition-colors"
            >
                Retry
            </button>
        </div>
    );
}
